import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import partsCategories, { Part } from '../partsCategories';
import SelectedParts from '../types/SelectedParts';

type Props = {
  selectedCategoryID: string;
  selectedParts: SelectedParts;
};

const displayNameForPart = (part: Part) => part.name.split('.')[0];

export default ({ selectedCategoryID, selectedParts }: Props) => {
  const selectedCategory = partsCategories.find(
    (category) => category.name === selectedCategoryID
  );
  const selectedPart = selectedParts[selectedCategoryID];
  const partNumber = selectedCategory.children.indexOf(selectedPart) + 1;

  const partsCount = selectedCategory.children.length;

  const selectedPartName = displayNameForPart(selectedPart).replace(
    '_none',
    'None'
  );

  return (
    <View style={styles.container}>
      <Text>{`${selectedPartName} (${partNumber}/${partsCount})`}</Text>
    </View>
  );
};

const HEIGHT = 22;

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 8,
    borderRadius: HEIGHT / 2,
    marginTop: -HEIGHT / 2,
    zIndex: 1000,
    height: HEIGHT,
  },
});
